<template>
    <div class="projectManage">        
        <top-component></top-component>
        <div class="content_wrap">
            <div class="add_all">
                <Button size="small" type="danger" @click="problemReport()">问题反馈</Button>
            </div>
            <div class="search-wrap">
                <Form :model="form" label-width="120px" size="mini">
                    <Row>                
                        <Col :span="12">
                            <FormItem label="时间：">
                                <div class="date-input">
                                    <FormItem class="no-margin">
                                        <DatePicker v-model="form.startdate" type="date" placeholder="起始时间" style="width:100%" />
                                    </FormItem>
                                </div>
                                <Col class="line" :span="1">-</Col>
                                <div class="date-input">
                                    <FormItem class="no-margin">
                                        <DatePicker v-model="form.finshdate" type="date" placeholder="结束时间" style="width:100%" />
                                    </FormItem>
                                </div>
                            </FormItem>
                        </Col>          
                        <Col :span="8">
                            <FormItem label="统计维度：">
                                <Select v-model="form.dimension" placeholder="请选择">
                                    <Option value="码洋" label="码洋"></Option>
                                    <Option value="品种" label="品种"></Option>
                                    <Option value="册数" label="册数"></Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <div class="search-btn">
                    <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                    <Button @click.native="resetForm" size="mini" class="iconfont icon-reset reset-btn">重置</Button>
                </div>
            </div>
            <div class="data_wrap">
                <h2 class="pro_title">项目进度</h2>               
                <ul class="clearfix_2 custorm">
                    <li>
                        <h2 v-if="form.dimension == '码洋'">{{resData.orderonway.factprice  || '-'}}</h2>
                        <h2 v-if="form.dimension == '册数'">{{resData.orderonway.factvolume  || '-'}}</h2>
                        <h2 v-if="form.dimension == '品种'">{{resData.orderonway.factvariety  || '-'}}</h2>
                        <span>当前已下单</span>
                    </li>
                    <li>
                        <h2 v-if="form.dimension == '码洋'">{{resData.shipped.factprice  || '-'}}</h2>
                        <h2 v-if="form.dimension == '册数'">{{resData.shipped.factvolume  || '-'}}</h2>
                        <h2 v-if="form.dimension == '品种'">{{resData.shipped.factvariety  || '-'}}</h2>
                        <span>已发货</span>
                    </li>
                    <li>
                        <h2>{{resData.settled || '-'}}</h2>
                        <span>已结算</span>
                    </li>
                </ul>
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
    import { Row, Col, Form, FormItem, Button, DatePicker, Select, Option } from 'element-ui'
    import TopComponent from "../Components/TopComponent.vue";
    import BottomComponent from "../Components/BottomComponent.vue";
    import Axios from "@/api/diyaxios";
    import Cookies from 'js-cookie'
    import { dateFormat } from '@/common/utils/utils'

    export default {
        data() {
            return {
                form: {
                    cpkid: Cookies.get('erpGid'),
                    startdate: null,
                    finshdate: null,
                    dimension: '码洋'
                },
                resData:{
                    shipped:{},
                    tobedelivered:{},
                    arrived:{},
                    dontarrive:{},
                    orderonway:{},
                }
            }
        },
        components: {
            TopComponent,
            Row, Col, Form, FormItem, Button, DatePicker, Select, Option,
            BottomComponent
        },
        mounted() {
            let vm = this;
        },
        methods: {
            onSubmit(){
                let vm = this;
                vm.getDataList();
            },
            //重置
            resetForm(){
                let vm = this;
                // vm.$refs.form.resetFields();
                vm.form.startdate = null;
                vm.form.finshdate = null;
                vm.form.dimension = '码洋';
            },
            getDataList(){
                let vm = this,
                    params = vm.form,
                    url = '/sxerp/pt/erpservice/crmworkorder/querySalesOrderProcessCustomer';
                if(params.startdate != null) params.startdate = dateFormat(vm.form.startdate, 'yyyy-MM-dd');
                if(params.finshdate != null) params.finshdate = dateFormat(vm.form.finshdate, 'yyyy-MM-dd');
                Axios.post(url, {
                    params: params,
                }).then(res => {
                    if(res.status){
                        vm.resData = res.data;
                    }
                }).catch(err => {

                })
            },
            // 问题反馈
            problemReport(){
                if (Cookies.get('token')) {
                    // this.$router.push({ name: 'SearchResult'})
                    this.$router.push({ name: 'ProblemReport' });
                }else{
                    this.$router.push({ name: 'Login'});
                }
            }
        }
    }
</script>

<style lang='scss'>
.projectManage{
    background-color: #f9f9f9;
    .content_wrap{
        margin: 20px auto;
        width: 1000px;
        background-color: #fff;
        padding: 40px 60px 140px;
        .el-form-item__content{
            .line{
                text-align: center;
            }
        }
        .date-input{
            float: left;
            width:130px;
            .el-input__inner{
                padding:0px 8px 0px 30px;
                width: 128px;
            }
        }
        .add_all{
            margin-bottom: 60px;
        }
        .search-btn{
            text-align: center;
            margin-top:20px;
            padding-bottom: 60px;
            border-bottom: 1px dashed #ccd7ea;
        } 
        .pro_title{
            color:#333;
            font-size:18px;
            margin-bottom: 60px;
        }       
        .data_wrap{
            padding-top: 30px;
            &.top{
                margin-top:4%;
            }
            ul.clearfix_2{
                &.custorm{
                    width: 595px;
                    height: 72px;
                    margin: 0px auto;
                    li{
                        border-top:1px solid #ccd7ea;
                    }
                }
                width: 1140px;
                border-left:1px solid #ccd7ea;
                li{
                    float: left;
                    width: 177px;
                    text-align: center;
                    list-style: none;
                    border-right:1px solid #ccd7ea;
                    border-bottom:1px solid #ccd7ea;
                    background-color: #fcfcf5;
                    padding:10px;
                    // &:nth-child(2n-1){
                    //     background-color: #f9fbfd;
                    // }
                    &.t{
                        border-top:1px solid #ccd7ea;
                        margin-top: -1px;
                    }
                    h2{
                        font-size:20px;
                        color:#2765b3;
                        // padding-bottom: 10px;
                    }
                    span{
                        font-size:18px;
                        color:#666;
                        font-weight: bold;
                    }
                    &.tit{
                        background-color: #f9fbfd;
                        width:102px;
                        span{
                            line-height: 47px;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/ProjectManage/index.vue